// Artemis chats for this page load. The panel unmounts when it closes, so the open chat and
// the ones before it live here instead, and come back when it reopens. Nothing is saved
// past a reload: saved chats need the v3 Conversations endpoints (see the Artemis guide).
//
// A chat: { id, title, messages, endedAt }. messages is chat-reducer state.

let current = []
let history = []
// The v3 conversation the open chat belongs to, once it has one.
let conversationId = null

export const currentConversationId = () => conversationId
export const setCurrentConversationId = id => { conversationId = id }

export const currentChat = () => current
export const setCurrentChat = messages => { current = messages }
export const pastChats = () => history

let nextId = 0

// Moves the open chat, if it has any messages, to the top of the past chats. Replies still
// streaming are marked stopped, since whoever read them has gone.
export const archiveCurrentChat = (at = Date.now()) => {
  if (current.length > 0) {
    const messages = current.map(m => m.status === 'streaming' ? { ...m, status: 'stopped', endedAt: at } : m)
    history = [{ id: `c${at.toString(36)}-${(nextId++).toString(36)}`, title: messages[0].question, messages, endedAt: at }, ...history]
  }
  current = []
  conversationId = null
}

// Opens a past chat: the open one is archived and the chosen one leaves the list.
export const openPastChat = (id, at = Date.now()) => {
  const chat = history.find(c => c.id === id)
  if (!chat) return current
  archiveCurrentChat(at)
  history = history.filter(c => c.id !== id)
  current = chat.messages
  return current
}

// For tests.
export const resetSession = () => { current = []; history = []; conversationId = null }
